import { createSlice } from "@reduxjs/toolkit";

const dashboardData = [];

const dashboardSliceData = createSlice({
    name: "dashboardSliceData",
    initialState: { dashboardData },
    reducers: {
        resetDashboardData(state) {
            state.dashboardData = dashboardData
        },
        setDashboardData(state, action) {
            state.dashboardData = action.payload
        },
    }
})

export const { setDashboardData, resetDashboardData } = dashboardSliceData?.actions;

export default dashboardSliceData?.reducer;